import React from 'react';

// Partner/Publication logos - using placeholder styling
const partners = [
  { name: "ICAI", subtitle: "Member Firm" },
  { name: "Startup India", subtitle: "Registered" },
  { name: "MSME", subtitle: "Certified" },
  { name: "ISO 27001", subtitle: "Compliant" },
  { name: "GST Network", subtitle: "Authorized" },
  { name: "MCA", subtitle: "Registered" },
];

const publications = [
  { name: "Economic Times", featured: true },
  { name: "Business Standard", featured: false },
  { name: "YourStory", featured: true },
  { name: "Inc42", featured: false },
];

export const PartnersLogos = () => {
  return (
    <section className="py-12 bg-gray-50 border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-4">
        {/* Certifications */}
        <p className="text-center text-sm text-gray-500 mb-6 uppercase tracking-wider font-semibold">
          Certified & Recognized By
        </p>
        
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {partners.map((partner, index) => (
            <div key={partner.name || `partner-${index}`} className="flex flex-col items-center group">
              <div className="w-16 h-16 bg-white rounded-xl shadow-sm border border-gray-200 flex items-center justify-center mb-2 group-hover:shadow-md transition-shadow">
                <span className="text-xs font-bold text-gray-700 text-center px-2">{partner.name}</span>
              </div>
              <span className="text-xs text-gray-500">{partner.subtitle}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const FeaturedIn = () => {
  return (
    <section className="py-8 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <p className="text-center text-sm text-gray-500 mb-6 uppercase tracking-wider font-semibold">
          As Featured In
        </p>
        
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-300">
          {publications.map((pub, index) => (
            <div key={name || `brand-${index}`} className="text-xl md:text-2xl font-serif font-bold text-gray-400 hover:text-gray-700 transition-colors cursor-default">
              {pub.name}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const TrustIndicators = () => {
  const stats = [
    { value: "100+", label: "Happy Clients", icon: "👥" },
    { value: "₹50Cr+", label: "Finances Managed", icon: "💰" },
    { value: "99.9%", label: "Compliance Rate", icon: "✅" },
    { value: "4.9★", label: "Client Rating", icon: "⭐" },
  ];

  return (
    <section className="py-12 bg-gradient-to-r from-emerald-600 to-teal-600">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={stat.label || `stat-${index}`} className="text-center text-white">
              <div className="text-3xl mb-2">{stat.icon}</div>
              <div className="text-3xl md:text-4xl font-bold mb-1">{stat.value}</div>
              <div className="text-emerald-100 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
